import { useCallback, useState } from 'react';

import BackButton, {
  CardPreview,
  Layout,
  OnboardingForm,
  StepProps,
} from '../../components';
import { OnboardingFormProps } from '../../components/OnboardingForm';
import { OnboardingStep } from '../../constants';
import OnboardingDesignContainer from '../OnboardingDesignContainer';
import OnboardingHeadlineContainer from '../OnboardingHeadlineContainer';
import OnboardingRecipientContainer from '../OnboardingRecipientContainer';
import OnboardingSenderContainer from '../OnboardingSenderContainer';

const STEP_COMPONENTS = {
  [OnboardingStep.RECIPIENT]: OnboardingRecipientContainer,
  [OnboardingStep.HEADLINE]: OnboardingHeadlineContainer,
  [OnboardingStep.DESIGN]: OnboardingDesignContainer,
  [OnboardingStep.SENDER]: OnboardingSenderContainer,
};

const STEP_ORDER = [
  OnboardingStep.RECIPIENT,
  OnboardingStep.HEADLINE,
  OnboardingStep.DESIGN,
  OnboardingStep.SENDER,
];

type Props = Pick<OnboardingFormProps, 'defaultValues' | 'onSubmit'> & Pick<StepProps, 'isSubmitting'>;

const OnboardingFormRouter = ({ isSubmitting, ...props }: Props) => {
  const [stepIndex, setStepIndex] = useState(
    props.defaultValues ? STEP_ORDER.length - 1 : 0,
  );
  const currentStep = STEP_ORDER[stepIndex];
  const StepComponent = STEP_COMPONENTS[currentStep];

  const handleNext = useCallback(() => {
    if (stepIndex < STEP_ORDER.length - 1) {
      setStepIndex((prevIndex) => prevIndex + 1);
    }
  }, [stepIndex]);

  const handlePrev = useCallback(() => {
    if (stepIndex > 0) {
      setStepIndex((prevIndex) => prevIndex - 1);
    }
  }, [stepIndex]);

  return (
    <OnboardingForm {...props}>
      {({ formValues, ...formProps }) => (
        <Layout rightPanel={<CardPreview formValues={formValues} />}>
          <StepComponent isSubmitting={isSubmitting} {...formProps} enablePrev={stepIndex > 0} onPrev={handlePrev} onNext={handleNext} />
          {stepIndex > 0 && <BackButton onClick={handlePrev} />}
        </Layout>
      )}
    </OnboardingForm>
  );
};

OnboardingFormRouter.displayName = 'OnboardingFormRouter';

export default OnboardingFormRouter;
